/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-unused-vars */
// from https://nso.edu/maps/v2/_js/20260812/coordinates.js
//<![CDATA[
/* BEGIN Eclipse Besselian Elements */
// INSTANT OF GREATEST ECLIPSE/GREATEST
const dateGE 		= "08/12/2026";
const dateGE_2 	= "2026-08-12";
const timeGE 		= "18:17:15"; // UT (18:18:29 TDT)
const julianGE 	= 2460409.26300; // julian date
const eph 		= "VSOP87/ELP2000-82"; // ephemerides
const timePeriod	= "SE2001"; // time period offset for eclipses 2001-2100
// link to eclipse api - http://api.usno.navy.mil/eclipses/solar?date=8/21/2017&coords=40,-105&format=json
// ** NOTE from John Lewis: this the new api endpoint https://aa.usno.navy.mil/api/eclipses/solar/date?date=2017-8-21%20&coords=46.67,%20-122.65%20&height=15
/*


            Equatorial Conjunction:     17:05:01.0 TDT     J.D. = 2461265.211818
              (Sun & Moon in R.A.)    (=17:03:49.6 UT)

             Ecliptic Conjunction:      17:37:53.5 TDT     J.D. = 2461265.234647
             (Sun & Moon in Ec. Lo.)  (=17:36:42.1 UT)

                  Instant of            17:47:05.2 TDT     J.D. = 2461265.241032
               Greatest Eclipse:      (=17:45:53.8 UT)


            --------------------------------------------------------------------------- 
                        Gamma =  0.8978            Ephemerides = VSOP87/ELP2000-85
            Eclipse Magnitude =  1.0386           Lunation No. =     329
                           ΔT =    71.4 s         Saros Series =  126 (48/72)

            Lunar Radius   k1 = 0.272488 (Penumbra)        Shift in      Δb =  0.00"
             Constants:    k2 = 0.272281 (Umbra)       Lunar Position:   Δl =  0.00"

            --------------------------------------------------------------------------- 
            Geocentric Coordinates of Sun & Moon at Greatest Eclipse (VSOP87/ELP2000-85):

            Sun:       R.A. = 09h29m47.3s         Moon:      R.A. = 09h31m17.3s
                       Dec. =+14°48'04.5"                    Dec. =+15°36'58.5"
              Semi-Diameter =    15'47.0"           Semi-Diameter =    16'16.9"
                Eq.Hor.Par. =       08.7"             Eq.Hor.Par. =  0°59'45.1"

            --------------------------------------------------------------------------- 
            Polynomial Besselian Elements for:   2026 Aug 12   18:00:00.0 TDT  (=t0)

              n        x          y         d          l1         l2          μ

              0   0.475593   0.771161   14.79667   0.537954  -0.008142   88.74776
              1   0.5189288 -0.2301664  -0.012065  0.0000940  0.0000935  15.003093
              2  -0.0000773 -0.0001245  -0.000003 -0.0000121 -0.0000121
              3  -0.0000088  0.0000037

                             Tan ƒ1 = 0.0046141    Tan ƒ2 = 0.0045911

            At time t1 (decimal hours), each Besselian element is evaluated by:

               a = a0 + a1*t + a2*t^2 + a3*t^3    (or a = Σ [an*t^n]; n = 0 to 3)

                  where:    a = x, y, d, l1, l2, or μ
                            t = t1 - t0  (decimal hours) and t0 = 18.000 TDT


            The Besselian elements were derived from a least-squares fit to elements
            calculated at five uniformly spaced times over a six hour period centered at t0.
            The Besselian elements are valid over the period 15.00 ≤ t0 ≤ 21.00 TDT.

            Note that all times are expressed in Terrestrial Dynamical Time (TDT).

                   Saros Series 126:  Member 48 of 72 eclipses in series.
	*/
	
// Coordinates of Greatest Eclipse 
// Lat = 65°13.5'N      Long = 025°13.7'W */		
const LatGE = 65.225000;
const LngGE = -25.228333;
		
/* Coordinates of Greatest Duration */
/* Lat =   65°50'N      Long =   025°29'W */
const LatGD = 65.8333;
const LngGD = -25.4833;		
		
/* END Eclipse Besselian Elements */
		
/* BEGIN Solar Eclipse Path Data */

// Shaded polygon eclipse path limits
const umbraCoords = [
  [ 74.91305, 117.95996 ],
  [ 75.17342, 108.68958 ],
  [ 77.05524, 108.67358 ],
  [ 77.90836, 108.43127 ],
  [ 78.56474, 108.11975 ],
  [ 79.11795, 107.7572 ],
  [ 79.60453, 107.35071 ],
  [ 80.04342, 106.90308 ],
  [ 80.44586, 106.41565 ],
  [ 80.81886, 105.88867 ],
  [ 81.16819, 105.32141 ],
  [ 81.49701, 104.71326 ],
  [ 81.8082, 104.06274 ],
  [ 82.10387, 103.36829 ],
  [ 82.38559, 102.62805 ],
  [ 82.65472, 101.83997 ],
  [ 82.91236, 101.00159 ],
  [ 83.15935, 100.11047 ],
  [ 83.39639, 99.16382 ],
  [ 83.62399, 98.15857 ],
  [ 83.84457, 97.08203 ],
  [ 84.06181, 95.90906 ],
  [ 84.27528, 94.63037 ],
  [ 84.48462, 93.23608 ],
  [ 84.68925, 91.71521 ],
  [ 84.88864, 90.05652 ],
  [ 85.08218, 88.24719 ],
  [ 85.26912, 86.27454 ],
  [ 85.44865, 84.125 ],
  [ 85.61987, 81.78589 ],
  [ 85.7817, 79.24512 ],
  [ 85.9331, 76.49207 ],
  [ 86.07288, 73.51855 ],
  [ 86.19969, 70.32141 ],
  [ 86.31223, 66.90332 ],
  [ 86.40922, 63.27283 ],
  [ 86.48925, 59.4491 ],
  [ 86.55123, 55.46155 ],
  [ 86.5943, 51.3407 ],
  [ 86.61751, 47.13757 ],
  [ 86.62061, 42.89954 ],
  [ 86.60357, 38.67908 ],
  [ 86.56672, 34.52942 ],
  [ 86.51058, 30.49182 ],
  [ 86.43619, 26.6095 ],
  [ 86.34464, 22.91504 ],
  [ 86.23689, 19.43066 ],
  [ 86.11461, 16.14697 ],
  [ 85.97667, 13.07483 ],
  [ 85.8305, 10.21741 ],
  [ 85.6722, 7.61609 ],
  [ 85.50469, 5.19983 ],
  [ 85.3286, 2.98108 ],
  [ 85.14503, 0.93811 ],
  [ 84.95475, -0.93994 ],
  [ 84.75854, -2.66797 ],
  [ 84.55696, -4.25525 ],
  [ 84.3507, -5.71606 ],
  [ 84.14024, -7.06042 ],
  [ 83.92599, -8.29846 ],
  [ 83.70835, -9.44006 ],
  [ 83.48764, -10.49365 ],
  [ 83.26426, -11.46631 ],
  [ 83.03841, -12.36609 ],
  [ 82.81039, -13.19763 ],
  [ 82.58037, -13.96802 ],
  [ 82.34859, -14.68152 ],
  [ 82.11516, -15.34375 ],
  [ 81.88026, -15.95813 ],
  [ 81.64404, -16.52844 ],
  [ 81.40659, -17.05872 ],
  [ 81.16802, -17.55164 ],
  [ 80.92846, -18.01001 ],
  [ 80.68794, -18.43677 ],
  [ 80.44658, -18.83374 ],
  [ 80.20441, -19.20337 ],
  [ 79.96158, -19.54749 ],
  [ 79.71809, -19.86792 ],
  [ 79.47395, -20.16626 ],
  [ 79.22929, -20.44385 ],
  [ 78.98411, -20.70227 ],
  [ 78.73846, -20.94263 ],
  [ 78.49239, -21.16602 ],
  [ 78.24593, -21.37366 ],
  [ 77.99911, -21.56628 ],
  [ 77.75195, -21.745 ],
  [ 77.50449, -21.91052 ],
  [ 77.25674, -22.0636 ],
  [ 77.00874, -22.20508 ],
  [ 76.76049, -22.33545 ],
  [ 76.51202, -22.45532 ],
  [ 76.26335, -22.56531 ],
  [ 76.01453, -22.66589 ],
  [ 75.76552, -22.75781 ],
  [ 75.51639, -22.84106 ],
  [ 75.26711, -22.91638 ],
  [ 75.01771, -22.98413 ],
  [ 74.7682, -23.04456 ],
  [ 74.5186, -23.09802 ],
  [ 74.26891, -23.14502 ],
  [ 74.01917, -23.18567 ],
  [ 73.76934, -23.22034 ],
  [ 73.51947, -23.24915 ],
  [ 73.26957, -23.27246 ],
  [ 73.01964, -23.29053 ],
  [ 72.76967, -23.30371 ],
  [ 72.51968, -23.31177 ],
  [ 72.26968, -23.31531 ],
  [ 72.01968, -23.31433 ],
  [ 71.7697, -23.30896 ],
  [ 71.51971, -23.29944 ],
  [ 71.26976, -23.28589 ],
  [ 71.01981, -23.26868 ],
  [ 70.76992, -23.24744 ],
  [ 70.52005, -23.22266 ],
  [ 70.27023, -23.19446 ],
  [ 70.02047, -23.16272 ],
  [ 69.77076, -23.12769 ],
  [ 69.52113, -23.0896 ],
  [ 69.27156, -23.04822 ],
  [ 69.02206, -23.00391 ],
  [ 68.77263, -22.95667 ],
  [ 68.52329, -22.90649 ],
  [ 68.27405, -22.85364 ],
  [ 68.02492, -22.79785 ],
  [ 67.77588, -22.7395 ],
  [ 67.52696, -22.67859 ],
  [ 67.27816, -22.61511 ],
  [ 67.02947, -22.54907 ],
  [ 66.78093, -22.48059 ],
  [ 66.53252, -22.40979 ],
  [ 66.28425, -22.33643 ],
  [ 66.03611, -22.26086 ],
  [ 65.78813, -22.18311 ],
  [ 65.54033, -22.10291 ],
  [ 65.29269, -22.02063 ],
  [ 65.04523, -21.93604 ],
  [ 64.79794, -21.84937 ],
  [ 64.55084, -21.7605 ],
  [ 64.30394, -21.66956 ],
  [ 64.05725, -21.57642 ],
  [ 63.81077, -21.48132 ],
  [ 63.5645, -21.38416 ],
  [ 63.31846, -21.28491 ],
  [ 63.07267, -21.18359 ],
  [ 62.82711, -21.08032 ],
  [ 62.58181, -20.9751 ],
  [ 62.33677, -20.8678 ],
  [ 62.09199, -20.75867 ],
  [ 61.84753, -20.64734 ],
  [ 61.60333, -20.5343 ],
  [ 61.35946, -20.41919 ],
  [ 61.11589, -20.30212 ],
  [ 60.87265, -20.18311 ],
  [ 60.62975, -20.06213 ],
  [ 60.38719, -19.93921 ],
  [ 60.14499, -19.81433 ],
  [ 59.90313, -19.68762 ],
  [ 59.66168, -19.55884 ],
  [ 59.4206, -19.42822 ],
  [ 59.17995, -19.29565 ],
  [ 58.93971, -19.16113 ],
  [ 58.69992, -19.02466 ],
  [ 58.46058, -18.88623 ],
  [ 58.22169, -18.74585 ],
  [ 57.98328, -18.60352 ],
  [ 57.74537, -18.45911 ],
  [ 57.50795, -18.31287 ],
  [ 57.27107, -18.16467 ],
  [ 57.03472, -18.0144 ],
  [ 56.79892, -17.86218 ],
  [ 56.5637, -17.70801 ],
  [ 56.32908, -17.55176 ],
  [ 56.09506, -17.39368 ],
  [ 55.86169, -17.23352 ],
  [ 55.62897, -17.07129 ],
  [ 55.39691, -16.9071 ],
  [ 55.16553, -16.74084 ],
  [ 54.93487, -16.57251 ],
  [ 54.70493, -16.40222 ],
  [ 54.47574, -16.22986 ],
  [ 54.24734, -16.05554 ],
  [ 54.01974, -15.87903 ],
  [ 53.79295, -15.70044 ],
  [ 53.56698, -15.5199 ],
  [ 53.34188, -15.33728 ],
  [ 53.11766, -15.15259 ],
  [ 52.89437, -14.9657 ],
  [ 52.67197, -14.77686 ],
  [ 52.45056, -14.58594 ],
  [ 52.23015, -14.39294 ],
  [ 52.01073, -14.19775 ],
  [ 51.79235, -14.00061 ],
  [ 51.57504, -13.80139 ],
  [ 51.35883, -13.59998 ],
  [ 51.14367, -13.39648 ],
  [ 50.92965, -13.19104 ],
  [ 50.71684, -12.9834 ],
  [ 50.50519, -12.7738 ],
  [ 50.29478, -12.56201 ],
  [ 50.08558, -12.34827 ],
  [ 49.87766, -12.13245 ],
  [ 49.67105, -11.91455 ],
  [ 49.46579, -11.69458 ],
  [ 49.26183, -11.47266 ],
  [ 49.05923, -11.24878 ],
  [ 48.85807, -11.02271 ],
  [ 48.65829, -10.79468 ],
  [ 48.45997, -10.5647 ],
  [ 48.26308, -10.33276 ],
  [ 48.06775, -10.09888 ],
  [ 47.87394, -9.86316 ],
  [ 47.6817, -9.62537 ],
  [ 47.49099, -9.38574 ],
  [ 47.30186, -9.14429 ],
  [ 47.11441, -8.90076 ],
  [ 46.92852, -8.65564 ],
  [ 46.74438, -8.40857 ],
  [ 46.56187, -8.15979 ],
  [ 46.38108, -7.90918 ],
  [ 46.20203, -7.65686 ],
  [ 46.02472, -7.40271 ],
  [ 45.84912, -7.14685 ],
  [ 45.67532, -6.88965 ],
  [ 45.50331, -6.63037 ],
  [ 45.3331, -6.36987 ],
  [ 45.16478, -6.10767 ],
  [ 44.99816, -5.84375 ],
  [ 44.83313, -5.57922 ],
  [ 44.66916, -5.31677 ],
  [ 44.51299, -5.04272 ],
  [ 44.35261, -4.77368 ],
  [ 44.19523, -4.50256 ],
  [ 44.03979, -4.22974 ],
  [ 43.88617, -3.95532 ],
  [ 43.7347, -3.67993 ],
  [ 43.58523, -3.40332 ],
  [ 43.43764, -3.12537 ],
  [ 43.29179, -2.84595 ],
  [ 43.14793, -2.56506 ],
  [ 43.00635, -2.28381 ],
  [ 42.86363, -1.99585 ],
  [ 42.71735, -1.69434 ],
  [ 42.56716, -1.37878 ],
  [ 42.41251, -1.047 ],
  [ 42.25276, -0.69666 ],
  [ 42.08708, -0.32495 ],
  [ 41.9144, 0.07202 ],
  [ 41.73326, 0.49963 ],
  [ 41.54163, 0.96521 ],
  [ 41.33654, 1.47949 ],
  [ 41.11324, 2.05969 ],
  [ 40.86329, 2.73621 ],
  [ 40.56877, 3.57397 ],
  [ 40.16867, 4.7959 ],
  [ 39.7085, 6.3407 ],
  [ 37.69017, 4.53943 ],
  [ 37.69017, 4.53943 ],
  [ 38.26708, 2.48242 ],
  [ 38.68237, 1.15552 ],
  [ 38.97947, 0.27087 ],
  [ 39.22908, -0.43604 ],
  [ 39.45103, -1.03955 ],
  [ 39.6543, -1.57336 ],
  [ 39.84386, -2.05603 ],
  [ 40.0228, -2.4989 ],
  [ 40.19319, -2.91003 ],
  [ 40.35652, -3.29468 ],
  [ 40.51389, -3.65723 ],
  [ 40.66614, -4.00061 ],
  [ 40.81393, -4.32739 ],
  [ 40.95778, -4.63965 ],
  [ 41.09813, -4.9386 ],
  [ 41.23534, -5.22595 ],
  [ 41.37141, -5.50452 ],
  [ 41.50906, -5.78271 ],
  [ 41.6488, -6.05957 ],
  [ 41.79718, -6.33081 ],
  [ 41.93372, -6.62195 ],
  [ 42.07941, -6.896 ],
  [ 42.22609, -7.16907 ],
  [ 42.3742, -7.44116 ],
  [ 42.52427, -7.71216 ],
  [ 42.67593, -7.98242 ],
  [ 42.82919, -8.2511 ],
  [ 42.98426, -8.51855 ],
  [ 43.14101, -8.78479 ],
  [ 43.2996, -9.04993 ],
  [ 43.45984, -9.31384 ],
  [ 43.62174, -9.57654 ],
  [ 43.78534, -9.83789 ],
  [ 43.95061, -10.0979 ],
  [ 44.11758, -10.35657 ],
  [ 44.28619, -10.61389 ],
  [ 44.45642, -10.87 ],
  [ 44.62834, -11.12451 ],
  [ 44.80183, -11.37781 ],
  [ 44.97692, -11.62952 ],
  [ 45.15356, -11.87988 ],
  [ 45.33182, -12.12866 ],
  [ 45.51164, -12.3761 ],
  [ 45.69296, -12.62207 ],
  [ 45.87581, -12.86646 ],
  [ 46.06017, -13.10938 ],
  [ 46.24604, -13.35071 ],
  [ 46.43333, -13.59058 ],
  [ 46.62203, -13.82886 ],
  [ 46.81216, -14.06555 ],
  [ 47.00368, -14.30066 ],
  [ 47.19664, -14.53418 ],
  [ 47.3909, -14.76611 ],
  [ 47.58652, -14.99646 ],
  [ 47.78344, -15.22522 ],
  [ 47.98168, -15.45227 ],
  [ 48.18119, -15.67773 ],
  [ 48.38195, -15.90161 ],
  [ 48.58393, -16.1239 ],
  [ 48.78711, -16.34448 ],
  [ 48.99147, -16.56348 ],
  [ 49.197,  -16.78076 ],
  [ 49.40369, -16.99646 ],
  [ 49.61145, -17.21057 ],
  [ 49.8203, -17.42297 ],
  [ 50.03028, -17.63367 ],
  [ 50.24129, -17.8429 ],
  [ 50.45335, -18.05042 ],
  [ 50.6664, -18.25635 ],
  [ 50.88043, -18.46069 ],
  [ 51.0954, -18.66345 ],
  [ 51.31133, -18.8645 ],
  [ 51.52819, -19.06396 ],
  [ 51.74594, -19.26184 ],
  [ 51.96458, -19.45813 ],
  [ 52.18407, -19.65295 ],
  [ 52.40438, -19.84607 ],
  [ 52.6255, -20.03772 ],
  [ 52.84743, -20.22778 ],
  [ 53.07013, -20.41626 ],
  [ 53.29359, -20.60327 ],
  [ 53.5178, -20.78882 ],
  [ 53.74272, -20.97278 ],
  [ 53.96834, -21.15527 ],
  [ 54.19464, -21.3363 ],
  [ 54.42163, -21.51587 ],
  [ 54.64926, -21.69397 ],
  [ 54.87753, -21.87061 ],
  [ 55.10641, -22.0459 ],
  [ 55.3359, -22.21973 ],
  [ 55.56595, -22.39221 ],
  [ 55.79662, -22.56323 ],
  [ 56.02779, -22.73303 ],
  [ 56.25953, -22.90137 ],
  [ 56.49178, -23.06836 ],
  [ 56.72454, -23.23413 ],
  [ 56.95781, -23.39856 ],
  [ 57.19154, -23.56165 ],
  [ 57.42577, -23.72339 ],
  [ 57.66043, -23.88403 ],
  [ 57.89557, -24.04333 ],
  [ 58.13112, -24.20142 ],
  [ 58.3671, -24.3584 ],
  [ 58.60348, -24.51404 ],
  [ 58.84026, -24.66858 ],
  [ 59.07743, -24.8219 ],
  [ 59.31498, -24.97412 ],
  [ 59.55288, -25.12512 ],
  [ 59.79114, -25.27502 ],
  [ 60.02974, -25.42383 ],
  [ 60.2687, -25.57153 ],
  [ 60.50798, -25.71814 ],
  [ 60.74756, -25.86377 ],
  [ 60.98747, -26.00818 ],
  [ 61.22765, -26.15173 ],
  [ 61.46813, -26.29419 ],
  [ 61.70892, -26.43555 ],
  [ 61.94997, -26.57593 ],
  [ 62.19129, -26.71533 ],
  [ 62.43287, -26.85376 ],
  [ 62.67469, -26.99121 ],
  [ 62.91679, -27.12769 ],
  [ 63.15911, -27.26318 ],
  [ 63.40167, -27.39783 ],
  [ 63.64446, -27.53149 ],
  [ 63.88747, -27.66431 ],
  [ 64.13069, -27.79614 ],
  [ 64.37413, -27.927 ],
  [ 64.61778, -28.05713 ],
  [ 64.86163, -28.18628 ],
  [ 65.10567, -28.31458 ],
  [ 65.34991, -28.44202 ],
  [ 65.59432, -28.56848 ],
  [ 65.83892, -28.69421 ],
  [ 66.0837, -28.81897 ],
  [ 66.32865, -28.94299 ],
  [ 66.57377, -29.06616 ],
  [ 66.81905, -29.18835 ],
  [ 67.06448, -29.30981 ],
  [ 67.31006, -29.43042 ],
  [ 67.55581, -29.55005 ],
  [ 67.8017, -29.66895 ],
  [ 68.04774, -29.78699 ],
  [ 68.29391, -29.90417 ],
  [ 68.54023, -30.02039 ],
  [ 68.78668, -30.13586 ],
  [ 69.03326, -30.25037 ],
  [ 69.27996, -30.36401 ],
  [ 69.52677, -30.47693 ],
  [ 69.77372, -30.58875 ],
  [ 70.02078, -30.69971 ],
  [ 70.26797, -30.80969 ],
  [ 70.51527, -30.91882 ],
  [ 70.76268, -31.02698 ],
  [ 71.01022, -31.13416 ],
  [ 71.25785, -31.24036 ],
  [ 71.50558, -31.34546 ],
  [ 71.75343, -31.44946 ],
  [ 72.00136, -31.55249 ],
  [ 72.24939, -31.65442 ],
  [ 72.49752, -31.75513 ],
  [ 72.74574, -31.85474 ],
  [ 72.99406, -31.95312 ],
  [ 73.24247, -32.05017 ],
  [ 73.49095, -32.146 ],
  [ 73.73952, -32.24048 ],
  [ 73.98818, -32.3335 ],
  [ 74.23692, -32.42505 ],
  [ 74.48573, -32.51514 ],
  [ 74.73463, -32.60352 ],
  [ 74.9836, -32.69031 ],
  [ 75.23264, -32.77527 ],
  [ 75.48175, -32.8584 ],
  [ 75.73092, -32.9397 ],
  [ 75.98018, -33.0188 ],
  [ 76.22949, -33.09583 ],
  [ 76.47886, -33.17053 ],
  [ 76.72829, -33.24292 ],
  [ 76.97778, -33.31262 ],
  [ 77.22733, -33.37976 ],
  [ 77.47692, -33.44397 ],
  [ 77.72658, -33.50525 ],
  [ 77.97628, -33.56299 ],
  [ 78.22601, -33.61755 ],
  [ 78.4758, -33.66833 ],
  [ 78.72565, -33.71497 ],
  [ 78.97549, -33.75745 ],
  [ 79.22536, -33.79541 ],
  [ 79.4753, -33.82849 ],
  [ 79.72523, -33.8562 ],
  [ 79.9752, -33.8783 ],
  [ 80.22518, -33.89404 ],
  [ 80.47518, -33.9032 ],
  [ 80.72517, -33.90515 ],
  [ 80.97517, -33.89917 ],
  [ 81.22515, -33.88464 ],
  [ 81.47513, -33.86072 ],
  [ 81.72507, -33.82654 ],
  [ 81.97498, -33.78101 ],
  [ 82.22484, -33.72314 ],
  [ 82.47466, -33.65161 ],
  [ 82.72439, -33.56506 ],
  [ 82.97408, -33.4613 ],
  [ 83.22363, -33.33923 ],
  [ 83.47306, -33.19617 ],
  [ 83.72237, -33.02954 ],
  [ 83.9715, -32.83679 ],
  [ 84.22047, -32.61401 ],
  [ 84.46922, -32.35669 ],
  [ 84.71762, -32.06116 ],
  [ 84.96571, -31.72107 ],
  [ 85.21346, -31.32922 ],
  [ 85.46072, -30.87744 ],
  [ 85.70745, -30.3551 ],
  [ 85.95353, -29.74939 ],
  [ 86.19882, -29.04529 ],
  [ 86.44318, -28.22119 ],
  [ 86.68634, -27.2511 ],
  [ 86.92796, -26.10303 ],
  [ 87.16779, -24.73145 ],
  [ 87.40518, -23.07495 ],
  [ 87.63941, -21.05554 ],
  [ 87.86935, -18.56067 ],
  [ 88.09367, -15.42847 ],
  [ 88.3101, -11.43359 ],
  [ 88.51469, -6.25317 ],
  [ 88.70245, 0.54712 ],
  [ 88.86464, 9.49512 ],
  [ 88.98946, 21.125 ],
  [ 89.06084, 35.29895 ],
  [ 89.06686, 50.6377 ],
  [ 89.00632, 65.08118 ],
  [ 88.89062, 77.14709 ],
  [ 88.7343, 86.56458 ],
  [ 88.5506, 93.71411 ],
  [ 88.3485, 99.14514 ],
  [ 88.13396, 103.32153 ],
  [ 87.91072, 106.58228 ],
  [ 87.68146, 109.16919 ],
  [ 87.44764, 111.25122 ],
  [ 87.21054, 112.94739 ],
  [ 86.97092, 114.34656 ],
  [ 86.72929, 115.51025 ],
  [ 86.48609, 116.48547 ],
  [ 86.24169, 117.30786 ],
  [ 85.99625, 118.00476 ],
  [ 85.75, 118.59741 ],
  [ 85.50301, 119.10205 ],
  [ 85.25548, 119.53223 ],
  [ 85.00748, 119.89868 ],
  [ 84.75909, 120.21057 ],
  [ 84.51028, 120.47461 ],
  [ 84.25629, 120.70081 ],
  [ 83.99529, 120.8938 ],
  [ 83.72649, 121.05542 ],
  [ 83.44931, 121.18762 ],
  [ 83.1628, 121.2915 ],
  [ 82.86614, 121.36841 ],
  [ 82.55804, 121.41882 ],
  [ 82.23731, 121.44348 ],
  [ 81.90179, 121.44141 ],
  [ 81.54945, 121.41235 ],
  [ 81.17735, 121.35498 ],
  [ 80.78177, 121.26733 ],
  [ 80.35742, 121.14587 ],
  [ 79.89673, 120.98535 ],
  [ 79.38815, 120.77747 ],
  [ 78.81217, 120.50732 ],
  [ 78.13074, 120.14563 ],
  [ 77.24567, 119.61633 ],
  [ 74.91305, 117.95996 ]
];

		
// Eclipse - green line Center eclipse line
	
const centerline_coords = [
  [ 75.07858, 113.45129 ],
  [ 77.18739, 114.20422 ],
  [ 78.0647, 114.34351 ],
  [ 78.73897, 114.36255 ],
  [ 79.30805, 114.3092 ],
  [ 79.80975, 114.20117 ],
  [ 80.26339, 114.04712 ],
  [ 80.68056, 113.85181 ],
  [ 81.06875, 113.6178 ],
  [ 81.43314, 113.34595 ],
  [ 81.77747, 113.03687 ],
  [ 82.10458, 112.68982 ],
  [ 82.41666, 112.30396 ],
  [ 82.71545, 111.87805 ],
  [ 83.00232, 111.41003 ],
  [ 83.2784, 110.89795 ],
  [ 83.54457, 110.33887 ],
  [ 83.80167, 109.72986 ],
  [ 84.05031, 109.0675 ],
  [ 84.29101, 108.34766 ],
  [ 84.52856, 107.55017 ],
  [ 84.76433, 106.66064 ],
  [ 84.99799, 105.66687 ],
  [ 85.22926, 104.55493 ],
  [ 85.4578, 103.30847 ],
  [ 85.68314, 101.90833 ],
  [ 85.90474, 100.33203 ],
  [ 86.12197, 98.55334 ],
  [ 86.33401, 96.54187 ],
  [ 86.53991, 94.26208 ],
  [ 86.73857, 91.67358 ],
  [ 86.92853, 88.73169 ],
  [ 87.10799, 85.38806 ],
  [ 87.27499, 81.59387 ],
  [ 87.42715, 77.30261 ],
  [ 87.56163, 72.48291 ],
  [ 87.67535, 67.12634 ],
  [ 87.76523, 61.26086 ],
  [ 87.82814, 54.97021 ],
  [ 87.86198, 48.38379 ],
  [ 87.86517, 41.67859 ],
  [ 87.83765, 35.05286 ],
  [ 87.78059, 28.69031 ],
  [ 87.69627, 22.72534 ],
  [ 87.5876, 17.25952 ],
  [ 87.45741, 12.35596 ],
  [ 87.30946, 7.92725 ],
  [ 87.14556, 4.02283 ],
  [ 86.96886, 0.57495 ],
  [ 86.78149, -2.46167 ],
  [ 86.58517, -5.13586 ],
  [ 86.38138, -7.49561 ],
  [ 86.17124, -9.58325 ],
  [ 85.95583, -11.43164 ],
  [ 85.73597, -13.07312 ],
  [ 85.51228, -14.5365 ],
  [ 85.28535, -15.84338 ],
  [ 85.05566, -17.01428 ],
  [ 84.82355, -18.06592 ],
  [ 84.58932, -19.01294 ],
  [ 84.35328, -19.86707 ],
  [ 84.11564, -20.63977 ],
  [ 83.87659, -21.33948 ],
  [ 83.63632, -21.97424 ],
  [ 83.39497, -22.55103 ],
  [ 83.15266, -23.07593 ],
  [ 82.9095, -23.55408 ],
  [ 82.66558, -23.99011 ],
  [ 82.42096, -24.38794 ],
  [ 82.17577, -24.75073 ],
  [ 81.93002, -25.08228 ],
  [ 81.68377, -25.38525 ],
  [ 81.4371, -25.66174 ],
  [ 81.19003, -25.91418 ],
  [ 80.94261, -26.14465 ],
  [ 80.69486, -26.35461 ],
  [ 80.44682, -26.54602 ],
  [ 80.19853, -26.72009 ],
  [ 79.95, -26.87805 ],
  [ 79.70129, -27.02124 ],
  [ 79.45239, -27.15051 ],
  [ 79.20334, -27.26709 ],
  [ 78.95414, -27.3717 ],
  [ 78.7048, -27.46533 ],
  [ 78.45535, -27.54834 ],
  [ 78.2058, -27.6217 ],
  [ 77.95618, -27.68591 ],
  [ 77.70644, -27.74158 ],
  [ 77.45666, -27.78918 ],
  [ 77.2068, -27.82935 ],
  [ 76.95692, -27.8623 ],
  [ 76.70699, -27.88855 ],
  [ 76.45703, -27.90833 ],
  [ 76.20706, -27.92224 ],
  [ 75.95707, -27.93054 ],
  [ 75.70708, -27.93335 ],
  [ 75.45707, -27.93103 ],
  [ 75.20708, -27.92395 ],
  [ 74.95709, -27.91223 ],
  [ 74.70712, -27.89612 ],
  [ 74.45718, -27.87585 ],
  [ 74.20728, -27.85156 ],
  [ 73.95739, -27.82349 ],
  [ 73.70755, -27.79175 ],
  [ 73.45776, -27.75647 ],
  [ 73.20802, -27.71802 ],
  [ 72.95832, -27.67627 ],
  [ 72.70868, -27.63135 ],
  [ 72.45909, -27.58362 ],
  [ 72.20956, -27.53296 ],
  [ 71.96011, -27.47961 ],
  [ 71.71072, -27.42358 ],
  [ 71.46142, -27.36499 ],
  [ 71.21217, -27.30396 ],
  [ 70.96301, -27.2406 ],
  [ 70.71396, -27.1748 ],
  [ 70.46498, -27.10681 ],
  [ 70.21609, -27.03662 ],
  [ 69.96732, -26.96436 ],
  [ 69.71864, -26.89001 ],
  [ 69.47008, -26.8136 ],
  [ 69.2216, -26.73523 ],
  [ 68.97324, -26.65503 ],
  [ 68.72502, -26.57288 ],
  [ 68.4769, -26.48901 ],
  [ 68.22891, -26.4032 ],
  [ 67.98104, -26.3158 ],
  [ 67.73332, -26.22644 ],
  [ 67.48573, -26.13562 ],
  [ 67.23828, -26.04297 ],
  [ 66.99098, -25.94873 ],
  [ 66.74383, -25.85291 ],
  [ 66.49683, -25.75549 ],
  [ 66.25001, -25.65637 ],
  [ 66.00335, -25.55579 ],
  [ 65.75685, -25.45374 ],
  [ 65.51054, -25.34998 ],
  [ 65.2644, -25.24487 ],
  [ 65.01846, -25.13806 ],
  [ 64.77271, -25.02991 ],
  [ 64.52716, -24.92017 ],
  [ 64.28181, -24.80908 ],
  [ 64.0367, -24.69641 ],
  [ 63.79178, -24.58228 ],
  [ 63.54708, -24.4668 ],
  [ 63.30263, -24.34973 ],
  [ 63.05841, -24.2312 ],
  [ 62.81443, -24.11133 ],
  [ 62.57072, -23.98987 ],
  [ 62.32726, -23.86707 ],
  [ 62.08408, -23.74268 ],
  [ 61.84116, -23.61694 ],
  [ 61.59854, -23.48975 ],
  [ 61.35621, -23.36096 ],
  [ 61.11417, -23.23083 ],
  [ 60.87245, -23.09924 ],
  [ 60.63106, -22.96606 ],
  [ 60.39, -22.83142 ],
  [ 60.14927, -22.69543 ],
  [ 59.90891, -22.55774 ],
  [ 59.6689, -22.4187 ],
  [ 59.42927, -22.27808 ],
  [ 59.19004, -22.13599 ],
  [ 58.9512, -21.99231 ],
  [ 58.71276, -21.84717 ],
  [ 58.47476, -21.70032 ],
  [ 58.23718, -21.552 ],
  [ 58.00005, -21.40222 ],
  [ 57.76336, -21.25073 ],
  [ 57.52715, -21.09766 ],
  [ 57.29142, -20.94299 ],
  [ 57.0562, -20.78687 ],
  [ 56.82151, -20.62891 ],
  [ 56.58733, -20.46948 ],
  [ 56.35371, -20.30835 ],
  [ 56.12066, -20.14563 ],
  [ 55.8882, -19.9812 ],
  [ 55.65633, -19.81506 ],
  [ 55.42507, -19.64722 ],
  [ 55.19441, -19.47778 ],
  [ 54.96442, -19.30664 ],
  [ 54.7351, -19.13379 ],
  [ 54.50647, -18.95911 ],
  [ 54.27851, -18.78271 ],
  [ 54.0513, -18.60461 ],
  [ 53.82483, -18.4248 ],
  [ 53.59913, -18.24316 ],
  [ 53.3742, -18.05981 ],
  [ 53.15008, -17.87463 ],
  [ 52.92677, -17.68774 ],
  [ 52.70432, -17.4989 ],
  [ 52.4827, -17.30847 ],
  [ 52.26203, -17.11609 ],
  [ 52.04226, -16.92188 ],
  [ 51.82338, -16.72595 ],
  [ 51.6055, -16.5282 ],
  [ 51.38858, -16.32849 ],
  [ 51.17265, -16.12708 ],
  [ 50.95776, -15.92383 ],
  [ 50.74393, -15.71863 ],
  [ 50.53116, -15.51172 ],
  [ 50.31949, -15.30286 ],
  [ 50.10892, -15.09229 ],
  [ 49.89953, -14.87976 ],
  [ 49.69131, -14.66553 ],
  [ 49.48428, -14.44934 ],
  [ 49.27844, -14.23145 ],
  [ 49.07389, -14.0116 ],
  [ 48.87059, -13.79004 ],
  [ 48.66858, -13.56665 ],
  [ 48.46788, -13.34143 ],
  [ 48.26851, -13.11438 ],
  [ 48.07053, -12.88562 ],
  [ 47.87392, -12.65503 ],
  [ 47.67873, -12.42261 ],
  [ 47.48493, -12.1886 ],
  [ 47.29263, -11.95276 ],
  [ 47.10178, -11.71509 ],
  [ 46.9124, -11.47583 ],
  [ 46.72458, -11.23474 ],
  [ 46.53827, -10.99207 ],
  [ 46.35352, -10.74768 ],
  [ 46.17039, -10.50159 ],
  [ 45.98882, -10.25391 ],
  [ 45.80886, -10.00464 ],
  [ 45.63053, -9.75378 ],
  [ 45.45391, -9.50134 ],
  [ 45.27891, -9.24719 ],
  [ 45.10557, -8.99158 ],
  [ 44.93396, -8.7345 ],
  [ 44.76405, -8.47595 ],
  [ 44.59592, -8.21594 ],
  [ 44.42951, -7.95447 ],
  [ 44.26491, -7.69153 ],
  [ 44.10202, -7.42712 ],
  [ 43.94083, -7.16138 ],
  [ 43.78159, -6.89441 ],
  [ 43.62406, -6.62622 ],
  [ 43.46827, -6.3562 ],
  [ 43.31458, -6.08594 ],
  [ 43.16376, -5.80139 ],
  [ 43.00826, -5.53271 ],
  [ 42.85969, -5.25769 ],
  [ 42.71319, -4.98169 ],
  [ 42.56864, -4.70508 ],
  [ 42.4259, -4.427 ],
  [ 42.28483, -4.14783 ],
  [ 42.14571, -3.86755 ],
  [ 42.00661, -3.58252 ],
  [ 41.86431, -3.28564 ],
  [ 41.71842, -2.97559 ],
  [ 41.56849, -2.65076 ],
  [ 41.41396, -2.30896 ],
  [ 41.25416, -1.94788 ],
  [ 41.0882, -1.56409 ],
  [ 40.91491, -1.15344 ],
  [ 40.73274, -0.71008 ],
  [ 40.53944, -0.22595 ],
  [ 40.3317, 0.3114 ],
  [ 40.10402, 0.922 ],
  [ 39.84632, 1.64307 ],
  [ 39.53514, 2.56091 ],
  [ 39.07173, 4.03955 ],
  [ 38.68051, 5.41431 ]
];
		


/* END Solar Eclipse Path Data */
		
//]]>

function arrayToGeoJsonFeature(coords: number[][]): GeoJSON.Feature<GeoJSON.LineString> {
  return {
    type: "Feature",
    geometry: {
      type: "LineString",
      coordinates: coords.map(([lat, lon]) => [lon, lat])
    },
    properties: {}
  };
}

function arrayToGeoJsonPolygon(coords: number[][]): GeoJSON.GeometryCollection {
  return {
    type: "GeometryCollection",
    geometries: [
      {
        type: "Polygon",
        coordinates: [coords.map(([lat, lon]) => [lon, lat])]
      }
    ]
  };
}

const umbra = arrayToGeoJsonFeature(umbraCoords);
// const extentN = arrayToGeoJsonFeature(extentN_coords);
// const extentS = arrayToGeoJsonFeature(extentS_coords);
const centerline = arrayToGeoJsonFeature(centerline_coords);

export default {
  centerline,
  umbra: arrayToGeoJsonPolygon(umbraCoords),
};